"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.merge = void 0;
const deepmerge_1 = require("deepmerge");
const merge = (previous, target) => {
    const cleaned = Object.fromEntries(Object.entries(target || {}).map(([key, value]) => !['undefined', 'null'].includes(key) && [key, value]).filter(Boolean));
    return (0, deepmerge_1.all)([previous || {}, cleaned], { arrayMerge: (_, source) => source });
};
exports.merge = merge;
const remove = (object, keys) => (object
    ? Object.entries(object).reduce((result, [key, value]) => (keys.includes(key) ? result : { ...result, [key]: value }), {})
    : {});
exports.remove = remove;
//# sourceMappingURL=object.js.map